import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ChevronRight16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.53033 2.46967L12.0607 8L6.53033 13.5303L5.46967 12.4697L9.93934 8L5.46967 3.53033L6.53033 2.46967Z'
      fill='currentColor'
    />
  </Svg>
);

ChevronRight16.displayName = 'ChevronRight16';
export default ChevronRight16;
